/* tslint:disable */
/* eslint-disable */
/**
 * Payment App-Tier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentMethodId = {
    CreditDebitCard: 'CREDIT_DEBIT_CARD',
    OnAccountBalance: 'ON_ACCOUNT_BALANCE',
    AmwayPoints: 'AMWAY_POINTS',
    CreditVoucher: 'CREDIT_VOUCHER',
    StaffEntitlement: 'STAFF_ENTITLEMENT',
    QrCode: 'QR_CODE',
    InstallmentPayment: 'INSTALLMENT_PAYMENT',
    OnlineBanking: 'ONLINE_BANKING',
    PayLaterQr: 'PAY_LATER_QR',
    Cash: 'CASH',
    BankPayout: 'BANK_PAYOUT',
    ThMpos: 'TH_MPOS',
    ThTms: 'TH_TMS',
    ThCnb: 'TH_CNB',
    ThPayLaterCnb: 'TH_PAY_LATER_CNB',
    ZeroChargePayment: 'ZERO_CHARGE_PAYMENT',
    DirectDebitBanking: 'DIRECT_DEBIT_BANKING',
    PayLaterCash: 'PAY_LATER_CASH',
    OfflineBanking: 'OFFLINE_BANKING',
    NgcRoundingPayment: 'NGC_ROUNDING_PAYMENT',
    BackToSource: 'BACK_TO_SOURCE',
    ManualPayout: 'MANUAL_PAYOUT',
    DownlinePayment: 'DOWNLINE_PAYMENT',
    PayLaterShop: 'PAY_LATER_SHOP',
    PayAtShop: 'PAY_AT_SHOP'
} as const;
export type PaymentMethodId = typeof PaymentMethodId[keyof typeof PaymentMethodId];


export function PaymentMethodIdFromJSON(json: any): PaymentMethodId {
    return PaymentMethodIdFromJSONTyped(json, false);
}

export function PaymentMethodIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodId {
    return json as PaymentMethodId;
}

export function PaymentMethodIdToJSON(value?: PaymentMethodId | null): any {
    return value as any;
}

